export default "__VITE_ASSET__DCFZSQkM__"